<template>
  <vue100vh style="position: fixed; width: 100%; overflow-y: hidden !important;">
  <v-container fluid>
    <v-layout row wrap class="hidden-md-and-up" :style="bgchat" >
      <v-flex xs12 sm12 md12 v-show="isShowFriendList === true">
         <LeftSideMobile @data="hideChat"></LeftSideMobile>
      </v-flex>
      <v-flex xs12 sm12 md12 v-show="isShowFriendList === false && isShowInfo == false">
        <!-- <CenterSideMobile @data="hideFrindList" @profile="hideInfo"></CenterSideMobile> -->
         <CenterSideTest @data="hideFrindList" @profile="hideInfo"></CenterSideTest>
      </v-flex>
      <v-flex xs12 sm12 md12 v-show="isShowFriendList === false && isShowChat === false && isShowInfo == true">
         <RightSideMobile @chat="hideChat" @data="hideFrindList"></RightSideMobile>
      </v-flex>
    </v-layout>
  </v-container>
</vue100vh>
</template>

<script>
import LeftSideMobile from '@/components/mobile/layout/LeftSideMobileTest'
// import CenterSideMobile from '@/components/mobile/layout/CenterSideMobile'
import CenterSideTest from '@/components/mobile/layout/CenterSideTest'
import RightSideMobile from '@/components/mobile/layout/RightSideMobile'
import vue100vh from 'vue-100vh'
export default {
  components: {
    LeftSideMobile,
    // CenterSideMobile,
    CenterSideTest,
    RightSideMobile,
    vue100vh
  },
  created () {
    this.isShowFriendList = false
    // this.status_login = this.$cookie.get('status_login')
    localStorage.setItem('room', this.$route.params.roomid)
    // console.log('created')
    // console.log(this.$route.params.room)
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  data () {
    return {
      status_login: '',
      isShowFriendList: true,
      isShowChat: true,
      isShowInfo: false,
      bgchat: 'background-color: #fff;',
      windowWidth: ''
    }
  },
  watch: {
    windowWidth () {
      if (this.windowWidth > 960) {
        if (!this.isShowFriendList) {
          this.$router.push('/chat/room/' + this.$route.params.roomid)
        } else {
          this.$router.push('/')
        }
      }
    }
  },
  methods: {
    logout () {
      localStorage.clear()
      // this.$router.push('/')
      if (process.env.LogoutOneid) {
        window.open(process.env.LogoutOneid, '_parent')
      } else {
        this.$router.push({path: '/', force: true})
      }
    },
    hideFrindList (status) {
      // console.log(status)
      // console.log('test3')
      this.isShowFriendList = status
      this.isShowChat = false
      this.isShowInfo = false
      this.bgchat = 'background-color: #fff;'
    },
    hideChat (status) {
      // console.log(status)
      // console.log('test2')
      this.isShowChat = status
      this.isShowFriendList = false
      this.isShowInfo = false
      this.bgchat = 'background-color: white;'
    },
    hideInfo (status) {
      // console.log(status)
      // console.log('miew')
      this.isShowInfo = status
      this.isShowChat = false
      this.isShowFriendList = false
      this.bgchat = 'background-color: white;'
    }
  }
}
</script>
<style type="text/css" scoped>
.container{
  padding: 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/mobile/layout/LayoutChatMobile.vue